import { createContext, useContext } from "react";

import { type ContextNodeAction } from "../state/index.ts";

type ContextPanelSelectedNodeContext = {
  contextPanelSelectedNodeId?: number;
  onContextPanelSelectedNodeIdChanged: (id?: number) => void;
  nodeActions: ContextNodeAction[];
};

export const ContextPanelSelectedNodeContext = createContext<ContextPanelSelectedNodeContext>(
  {} as ContextPanelSelectedNodeContext,
);
ContextPanelSelectedNodeContext.displayName = "ContextPanelSelectedNodeContext";

export const useContextPanelSelectedNode = () => {
  const context = useContext(ContextPanelSelectedNodeContext);

  if (!context) throw new Error(`Missing ContextPanelSelectedNodeProvider in component tree.`);

  return context;
};
